
import { FaUserInjured, FaUserMd, FaBuilding } from "react-icons/fa";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
const Trusted = () => {

  const navigate = useNavigate();
  const logos = [
  "/logo/IITPatnaLogo.png",
  "/logo/ABDM.png",
  "/logo/Rishikesh.png",
  "/logo/WadhwaniFoundation.jpg",
  "/logo/startup_india.png",
  "/logo/cdac.jfif"
];

const metrics = [
  {
    title: "AVG. CONSULTING TIME",
    before: "20",
    after: "14",
    unit: "min",
    badge: "▼ 30% reduction",
    description:
      "AI-gathered history eliminates repetitive intake questions, giving clinicians a structured summary before the appointment begins.",
    oldValue: "20m",
    newValue: "14m",
    progress: "60%",
  },
  {
    title: "PATIENTS HANDLED / DAY",
    before: "30",
    after: "45",
    unit: "",
    badge: "▲ 50% more capacity",
    description:
      "Six minutes recovered per consultation compounds across a full day — unlocking 15 additional patient slots within existing hours.",
    oldValue: "30",
    newValue: "45",
    progress: "100%",
  },
  {
    title: "POPULATION COVERAGE",
    before: "0.7",
    after: "~1",
    unit: "",
    badge: "▲ 43% wider reach",
    description:
      "Per 1,000 population served. Closing the gap from 0.7 to near-universal coverage — without additional staff or infrastructure.",
    oldValue: "0.7×",
    newValue: "~1×",
    progress: "100%",
  },
];


  return (
    <section className="w-full border-t border-gray-200 dark:border-white/10">
      
      {/* HEADING */}
      <div className="text-center py-8 px-4">
        <p className="text-sm sm:text-base text-gray-700 dark:text-gray-300 font-medium">
          Trusted by 3000+ users from these organizations
        </p>
      </div>

      {/* GRID */}
      <div
        className="
        grid 
        grid-cols-2 
        sm:grid-cols-3 
        md:grid-cols-4 
        lg:grid-cols-6
        border-t border-gray-200 dark:border-white/10
      "
      >
        {logos.map((logo, index) => (
          <div
            key={index}
            className="
              flex items-center justify-center 
              p-6 sm:p-8 
              border-b border-r 
              border-gray-200 dark:border-white/10
              bg-white dark:bg-[#0d0d0d]
              hover:bg-gray-50 dark:hover:bg-white/5
              transition
            "
          >
            <img
              src={logo}
              alt="company"
              className="
                max-h-20 sm:max-h-40 
                opacity-60 
                hover:opacity-100 
                transition
                grayscale hover:grayscale-0
              "
            />
          </div>
        ))}
      </div>

{/* PRE-CONSULTATION SECTION */}
<section 
id="pre-consultation"
className="bg-white text-black dark:bg-black dark:text-white py-20 px-6 md:px-16 transition-colors duration-300 mt-10">
  <div className="max-w-7xl mx-auto">

    {/* Heading */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-5xl font-semibold mb-4">
        AI-aided Pre-consultation that pays for itself
      </h2>
      <p className="max-w-2xl mx-auto text-gray-600 dark:text-gray-400">
        A pre-consultation intake tool. Patients tell their story before the consultation, at home or in the practice. Our pre-consultant prepares a brief summary for the clinician to review beforehand.
      </p>
    </div>

    {/* Main Grid */}
    <div className="space-y-10">

  {/* Top Section */}
  <div className="grid md:grid-cols-2 gap-10 items-start">

    {/* LEFT SIDE */}
    <div className="space-y-14">
      {[
        {
          icon: <FaUserInjured className="text-orange-400 text-xl mt-1" />,
          text: (
            <>
              <span className="font-medium">Patient:</span> Why do I have
              to wait for so long to see the doctor who consults in just
              10 minutes?
            </>
          ),
        },
        {
          icon: <FaUserMd className="text-blue-400 text-xl mt-1" />,
          text: (
            <>
              <span className="font-medium">Doctor:</span> Why am I working
              from morning to evening, and the patient still says this?
            </>
          ),
        },
        {
          icon: <FaBuilding className="text-green-400 text-xl mt-1" />,
          text: (
            <>
              <span className="font-medium">Government:</span> Why do we
              always need more resources for healthcare?
            </>
          ),
        },
      ].map((item, index) => (
        <div
          key={index}
          className="flex items-start gap-4 p-5 rounded-2xl border bg-gray-100 border-gray-200 dark:bg-gray-900/50 dark:border-gray-700"
        >
          {item.icon}
          <p className="text-gray-700 dark:text-gray-300">
            {item.text}
          </p>
        </div>
      ))}
    </div>

    {/* RIGHT SIDE */}
    <div className="space-y-6">

      {/* Assistant Card */}
      <div className="p-6 rounded-2xl border bg-gray-100 border-gray-200 dark:bg-gray-900/50 dark:border-gray-700">
        <h3 className="text-xl font-semibold mb-3">
          Meet our pre-consultant assistant
        </h3>
        <p className="text-gray-600 dark:text-gray-400">
          An autonomous junior healthcare assistant that performs initial
          assessments, prepares concise reports, and assists doctors before
          consultation. It saves up to <b>30%</b> of doctors' time.
        </p>
      </div>

      {/* Image */}
      <div className="rounded-2xl overflow-hidden">
        <img
          src="../img/aayush2.png"
          alt="AI Healthcare"
          className="w-full h-full object-cover"
        />
      </div>

    </div>
  </div>

  {/* Video Section */}
  <div className="flex justify-center">
    <div className="w-full md:w-3/4 overflow-hidden rounded-2xl shadow-lg">
      <video
        className="w-full h-full object-cover"
         controls
  controlsList="nodownload noplaybackrate"
  disablePictureInPicture
  autoPlay
  muted
  loop
  playsInline
      >
        <source
          src="/img/Clinical AI Demo.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>

</div>
  </div>
</section>
 <section className="relative py-20">
      <div className="max-w-7xl mx-auto px-4">

        {/* Top Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {metrics.map((item, index) => (
            <div
              key={index}
              className="
                rounded-3xl border
                bg-white
                border-gray-200
                dark:bg-[#07111f]/80
                dark:border-cyan-500/20
                backdrop-blur-sm
                p-8
                relative
                overflow-hidden
              "
            >
              {/* glow */}
              <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-cyan-400 via-emerald-400 to-transparent" />

              <p className="text-xs tracking-[0.3em] uppercase text-gray-500 dark:text-gray-400 mb-8">
                {item.title}
              </p>

              <div className="flex items-center gap-4 mb-6">
                <div className="text-gray-400 line-through text-5xl font-light">
                  {item.before}
                </div>

                <ArrowRight
                  size={22}
                  className="text-gray-400"
                />

                <div className="text-cyan-400 text-6xl font-light">
                  {item.after}
                  <span className="text-3xl">{item.unit}</span>
                </div>
              </div>

              <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
                {item.description}
              </p>

              <div className="inline-flex items-center px-4 py-2 rounded-xl border border-cyan-500/30 bg-cyan-500/10 text-cyan-400 text-sm mb-8">
                {item.badge}
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <span className="w-10 text-gray-500">was</span>

                  <div className="flex-1 h-2 rounded-full bg-gray-200 dark:bg-white/10">
                    <div className="h-full w-full rounded-full bg-gray-400" />
                  </div>

                  <span className="text-gray-500 text-sm">
                    {item.oldValue}
                  </span>
                </div>

                <div className="flex items-center gap-4">
                  <span className="w-10 text-gray-500">now</span>

                  <div className="flex-1 h-2 rounded-full bg-gray-200 dark:bg-white/10">
                    <div
                      className="h-full rounded-full bg-cyan-400"
                      style={{ width: item.progress }}
                    />
                  </div>

                  <span className="text-gray-500 text-sm">
                    {item.newValue}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div
          className="
            mt-8
            rounded-3xl
            border
            border-gray-200
            dark:border-cyan-500/20
            bg-white
            dark:bg-[#07111f]/80
            backdrop-blur-sm
            p-8 md:p-12
          "
        >
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">

            <div>
              <h3 className="text-3xl font-serif text-gray-900 dark:text-white mb-3">
                15 extra appointments a day.
              </h3>

              <p className="text-2xl italic text-emerald-500 mb-4">
                The subscription pays for itself before lunch.
              </p>

              <p className="text-gray-500 dark:text-gray-400">
                Based on 6-minute saving per consult across a
                30-patient baseline day.
              </p>
            </div>

            <button
            onClick={() => {navigate("/vision")}}
              className="
                px-10 py-5
                rounded-2xl
                bg-gradient-to-r
                from-cyan-400
                to-emerald-400
                text-black
                font-semibold
                tracking-wider
                uppercase
                hover:scale-105
                transition
              "
            >
              See It In Action →
            </button>
          </div>
        </div>
      </div>
    </section>
    </section>
  );
};

export default Trusted;